import { silentInstallApps } from '#packages/platform';
import { ErrorReporter } from '@wix/editor-error-reporter';

import type { EditorAPI } from '#packages/editorAPI';
import type { InstallAppsHookFn } from '#packages/editorCore';

export const getSilentInstallAppsFn = (
  editorAPI: EditorAPI,
): InstallAppsHookFn => {
  return (appDefIds, appsOptions, platformOrigin, options = {}) => {
    return new Promise<void>((resolve) => {
      silentInstallApps(editorAPI, appDefIds, {
        appsOptions,
        disableHistoryRevert: true,
        installOrigin: platformOrigin,
        ...options,
      })
        .then(resolve)
        .catch((e) => {
          ErrorReporter.captureException(e, {
            tags: { failedOnSilentInstallApps: true },
            extra: {
              appDefIds,
              appsOptions,
            },
          });
          resolve();
        });
    });
  };
};

export const getHeadlessInstallAppsFn = (
  editorAPI: EditorAPI,
): InstallAppsHookFn => {
  return async (appDefIds, appsInstallOptions, platformOrigin) => {
    for (const appDefId of appDefIds) {
      const options = appsInstallOptions[appDefId] || {};
      await editorAPI.tpa.installAppIfNeeded(appDefId, {
        ...options,
        isSilent: true,
        platformOrigin,
        headlessInstallation: true,
        biData: {
          origin: platformOrigin?.info?.type || 'Editor',
        },
      });
    }
  };
};
